import React, { useEffect, useState } from "react";
import { Button } from "primereact/button";
import { Dialog } from "primereact/dialog";
import { InputText } from "primereact/inputtext";
import { useNavigate } from "react-router-dom";
import SuccessModal from "../../SuccessModal";
import { customerUpdate } from "../../../services/CustomerInfo/EditCustomer";
import { getStoreCustomerSource } from "../../../services/CustomerInfo/CustomerInfo";
import { Dropdown } from "primereact/dropdown";

export default function EditCustomerSourceModal({
  setEditCustomerSourceModalVisible,
  editCustomerSourceModalVisible,
  sourceName,
  editCustomerData,
  storeId,
  sendDataToEditCustomer
}) {
  const navigate = useNavigate();

  const [sourceValue, setSourceValue] = useState(sourceName);
  const [sourceError, setSourceError] = useState("");
  const [sourceItems, setSourceItems] = useState([]);

  
  const fetchStoreCustomerSource = async () => {
    try {
      const response = await getStoreCustomerSource(storeId);
      if (!response.data.error) {
        const Res = response.data.map((item, index) => ({
          name:item.name,
          value: item.name
        }));
        setSourceItems(Res)
        
      }
    } catch (error) {
      console.error("Error:", error);
    }
  };

  useEffect(() => {
    fetchStoreCustomerSource();
  }, []);

  const handleEditData = async () => {
    // Create a new edited field object
    
    // Update the specific field in editCustomerData
    let updatedData = { ...editCustomerData };
     
      updatedData.brandCustomer.source = sourceValue;
     
    // Add more conditions for other fields
    try {
      const response = await customerUpdate(updatedData);
      if (!response.data.error) {
        const Res = response.data;
        const message = Res.message;
        const status = Res.status;

        // Close the modal
        setEditCustomerSourceModalVisible(false);
        sendDataToEditCustomer({
          success: true,
        });
        if (status === true) {
          setModalVisible(true);
          setModalStatus("success");
          setModalText(message);
        } else {
          setModalVisible(true);
          setModalStatus("not Success");
          setModalText(message);
        }
        // if (Res) {
        //   sendDataToEditCustomer({
        //     success: true,
        //   });
        // }
      }
    } catch (error) {
      console.error("Error:", error);
    }

    // Close the modal
    setEditCustomerSourceModalVisible(false);
  };

  useEffect(() => {
    // When the fieldNameName or fieldNameValue changes, update the editValue
    if (
      sourceName !== null
    ) {
      setSourceValue(sourceName);
    }
  }, [sourceName]);

  //         //

  const [modalVisible, setModalVisible] = useState(false);
  const [modalStatus, setModalStatus] = useState(false);
  const [modalText, setModalText] = useState("");

  const handleModalClose = () => {
    setEditCustomerSourceModalVisible(false);
    // setEditValue
    // setEditLastNameValue
  };

  return (
    <div className="flex justify-content-center">
      <Dialog
        modal
        visible={editCustomerSourceModalVisible}
        style={{ width: "50vw" }}
        onHide={() => {
          if (!editCustomerSourceModalVisible) return;
          handleModalClose();
        }}
        content={({ hide }) => (
          <div
            className="flex flex-column gap-4 "
            style={{
              borderRadius: "12px",
              backgroundColor: "#fff",
            }}
          >
            <div
              className="flex border-round-xl  justify-content-between align-items-center gap-2 px-4 py-2"
              style={{
                backgroundImage:
                  "radial-gradient(circle at left top, #2B70D7, #1752AA)",
              }}
            >
              <i
                className="pi pi-user"
                style={{ fontSize: "50px", color: "#fff" }}
              ></i>
              <p className=" text-4xl text-primary-50 font-semibold">
                Edit Source
              </p>
              <Button
                label="x"
                onClick={(e) => hide(e)}
                text
                className=" text-2xl text-primary-50 border-1 border-white-alpha-30 hover:bg-white-alpha-10"
              ></Button>
            </div>
            <div className="mx-4">
            <Dropdown
                id="sourceValue"
                value={sourceValue}
                onChange={(e) => {setSourceValue(e.value);setSourceError("")}}
                options={sourceItems}
                optionLabel="name"
                placeholder="Source"
                className="w-full border-round-xl  text-2xl text-xl shadow-2"
              />
              {sourceError && (
                <p className="text-lg font-normal" style={{ color: "red" }}>
                  {sourceError}
                </p>
              )}
            </div>

            <Button
              onClick={handleEditData}
              className="mt-1 mb-3 mx-4 border-round-xl "
            >
              <p className=" w-full text-2xl font-semibold flex justify-content-center">
                Submit
              </p>
            </Button>
          </div>
        )}
      ></Dialog>
      <div>
        <SuccessModal
          modalVisible={modalVisible}
          setModalVisible={setModalVisible}
          status={modalStatus}
          text={modalText}
        />
      </div>
    </div>
  );
}
